module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer3_no-inverter_lt 1.d9a4a3eb.svg";